
import React, { Component } from "react";
import { Container, Col, Row, Media } from "reactstrap";
import Market_Trends from "./Market_Trends";
import KPI_Trends from "./KPI_Trends";

export default class WidgetView2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
     
      widgetselectionsKPI: {
        measure: "InventoryCount,SoldCount,SoldMedDOM",
      geo:this.props.geo
      },
      widgetselectionsMT: {       
        measure:'MedSalePrice,AvgSaleOverListPrice',
        periodtype:'Month',
        period:'24',        
        classtype:"Residential - Single Family" ,      
         geo: this.props.geo
      },

    };
 
  }

  componentWillReceiveProps(nextProps) {
    let widgetselectionsMT = { ...this.state.widgetselectionsMT };
    let widgetselectionsKPI = { ...this.state.widgetselectionsKPI }; 
    widgetselectionsKPI.geo = nextProps.geo;
     widgetselectionsMT.geo = nextProps.geo;  
    this.setState({ widgetselectionsKPI, widgetselectionsMT });
  }

  

  render() {
  let chartOptions = {
  titleclasses: "row justify-content-center title mx-0",
  chartclasses: "mb-4",
  optionclasses: "justify-content-center",
  widgetoptions: this.state.widgetselectionsMT,
  assets: "",
 
}; 
 
    return (
      <Container   className="px-0 mt-4">
      <Row className="px-0">  
      <Col  sm="10" className="px-0">    
          <Market_Trends {...chartOptions}>
          </Market_Trends>
          </Col>
         
       
          <Col sm={{ size: 'auto'}} sm="2"  className="px-0 kpicol">  
    <div className="acu_kpiTitle">
   Key Performance Indicators based on last 30 days
   {/* - {this.state.widgetselectionsKPI.geo[0].split(':')[1]}  */}
   </div> 
    <KPI_Trends title='swap' widgetoptions={this.state.widgetselectionsKPI} assets="" />
    </Col>
      
      </Row>

 
    </Container>

    );
  }
}



// WEBPACK FOOTER //
// ./src/w2.js